// FETCH ALL PROPERTIES FROM BANK MASTER
export const FETCH_BANK_MASTER_REQUEST = 'FETCH_BANK_MASTER_REQUEST';
export const FETCH_BANK_MASTER_SUCCESS = 'FETCH_BANK_MASTER_SUCCESS';
export const FETCH_BANK_MASTER_FAILURE = 'FETCH_BANK_MASTER_FAILURE';

// FETCH ALL BANK LIST FROM BANK MASTER
export const FETCH_BANK_LIST_FROM_BANK_MASTER_REQUEST = 'FETCH_BANK_LIST_FROM_BANK_MASTER_REQUEST';
export const FETCH_BANK_LIST_FROM_BANK_MASTER_SUCCESS = 'FETCH_BANK_LIST_FROM_BANK_MASTER_SUCCESS';
export const FETCH_BANK_LIST_FROM_BANK_MASTER_FAILURE = 'FETCH_BANK_LIST_FROM_BANK_MASTER_FAILURE';

// CREATE PROPERTIES FOR BANK MASTER
export const CREATE_BANK_MASTER_REQUEST = 'CREATE_BANK_MASTER_REQUEST';
export const CREATE_BANK_MASTER_SUCCESS = 'CREATE_BANK_MASTER_SUCCESS';
export const CREATE_BANK_MASTER_FAILURE = 'CREATE_BANK_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_BANK_MASTER = 'CREATE_USER_FORM_BANK_MASTER';

// UPDATE PROPERTIES FOR BANK MASTER
export const UPDATE_BANK_MASTER_REQUEST = 'UPDATE_BANK_MASTER_REQUEST';
export const UPDATE_BANK_MASTER_SUCCESS = 'UPDATE_BANK_MASTER_SUCCESS';
export const UPDATE_BANK_MASTER_FAILURE = 'UPDATE_BANK_MASTER_FAILURE';

// FETCH SINGLE BANK
export const FETCH_SINGLE_BANK_MASTER_REQUEST = 'FETCH_SINGLE_BANK_MASTER_REQUEST';
export const FETCH_SINGLE_BANK_MASTER_SUCCESS = 'FETCH_SINGLE_BANK_MASTER_SUCCESS';
export const FETCH_SINGLE_BANK_MASTER_FAILURE = 'FETCH_SINGLE_BANK_MASTER_FAILURE';

// DELETE PROPERTIES FOR BANK MASTER
export const DELETE_BANK_MASTER_REQUEST = 'DELETE_BANK_MASTER_REQUEST';
export const DELETE_BANK_MASTER_SUCCESS = 'DELETE_BANK_MASTER_SUCCESS';
export const DELETE_BANK_MASTER_FAILURE = 'DELETE_BANK_MASTER_FAILURE';

// USERFORM RESET

export const BANK_MASTER_USERFORM_RESET = 'BANK_MASTER_USERFORM_RESET';
